import React, { useEffect, useState } from 'react';
import './TheTeacherDashboard.css';
import COG from './imageFiles/COG.png';
import { dashChartTypesEdsider } from '../../../../../../helper/namespace';

export default function ExamCountGrades({ paper_count_on_grade, dashboardDataLoading }) {
  const [activeTab, setActiveTab] = useState('English');

  const [edsider_teacher_grade_paper_count_english, setEnglish] = useState([]);
  const [edsider_teacher_grade_paper_count_sinhala, setSinhala] = useState([]);
  const [edsider_teacher_grade_paper_count_tamil, setTamil] = useState([]);

  const findChartTypedArray = (chart_type, allChartTypes = []) => {
    return allChartTypes.filter(item => item.language_name === chart_type);
  }

  useEffect(() => {

    setEnglish(findChartTypedArray("English", paper_count_on_grade));
    setSinhala(findChartTypedArray("සිංහල", paper_count_on_grade));
    setTamil(findChartTypedArray("தமிழ்", paper_count_on_grade));

  }, [paper_count_on_grade]);

  const getCurrentTabData = () => {
    switch (activeTab) {
      case 'English':
        return edsider_teacher_grade_paper_count_english;
      case 'සිංහල':
        return edsider_teacher_grade_paper_count_sinhala;
      case 'தமிழ்':
        return edsider_teacher_grade_paper_count_tamil;
      default:
        return [];
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="exam-count-subjects">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="section-title-teacher">Paper Count on Grades</h6>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="tabs-section d-flex align-items-center mb-3">
        <div>&emsp;</div>
        <div className="tabs">
          {['English', 'සිංහල', 'தமிழ்'].map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <span className="dots-icon ms-auto">⋯</span>
      </div>

      <div className="subject-list">
        {!dashboardDataLoading && getCurrentTabData()?.length > 0 ? (

          getCurrentTabData()?.map((grade, index) => (
            <div className="subject-row d-flex align-items-center mb-3" key={index}>
              <img src={COG} alt="subject icon" className="subject-icon me-3" />
              <span className="subject-name flex-grow-1">Grade {grade?.grade_name || "N/A"}</span>
              <span className="subject-count">({grade?.paper_count || "N/A"})</span>
            </div>
          ))

        ) : (

          dashboardDataLoading ?
            <div
              className="stu-card-title pt-2 col-md-12"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            :
            <>
              No Data
            </>

        )}

      </div>
    </div>
  );
}
